export function noofburger(cf) {
  return Math.round((cf * 1000) / 9.73);
}
